import { Box, Typography } from '@mui/material'
import { SplitButton } from './SplitButton'
import { Button } from 'Common/Supplyvue-ui'
import { useState } from 'react'
import { useTheme } from '@mui/material/styles'
import { DashboardToggleProps } from './DashboardToggle.types'

export const DashboardToggle = ({
  options,
  handleSelectedOption,
  handleToggleButton,
}: DashboardToggleProps) => {
  const theme = useTheme()
  const [selectedIndex, setSelectedButtonIndex] = useState(0)

  const handleRightButtonClick = () => {
    if (selectedIndex != 1) {
      setSelectedButtonIndex(1)
      handleToggleButton()
    }
  }
  return (
    <Box display="flex">
      <Box>
        <SplitButton
          setSelectedButtonIndex={setSelectedButtonIndex}
          enabled={selectedIndex === 0}
          options={options}
          handleSelectedOption={handleSelectedOption}
          handleToggleButton={handleToggleButton}
        />
      </Box>
      <Box>
        <Button
          sx={{
            borderRadius: 0,
            minWidth: '120px',
            height: '100%',
          }}
          variant={selectedIndex === 1 ? 'contained' : 'outlined'}
          onClick={handleRightButtonClick}
        >
          <Typography variant="h4">Planning book</Typography>
        </Button>
      </Box>
    </Box>
  )
}
